export default __webpack_public_path__ + "static/img-app-leaderboard--mobile-39e82322cf8b04be3f09929a6dfbf733.jpg";